"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpenetrableDefenseEffectHandler = exports.ImpenetrableDefenseEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class ImpenetrableDefenseEffectArgs {
    constructor(increase) {
        this.increase = increase;
        this.__type = EffectType_1.EffectType.ImpenetrableDefense;
        this.__typeName = "ImpenetrableDefense";
        this.name = "Impenetrable Defense";
        this.harmful = true;
    }
}
exports.ImpenetrableDefenseEffectArgs = ImpenetrableDefenseEffectArgs;
let ImpenetrableDefenseEffectHandler = class ImpenetrableDefenseEffectHandler {
    apply(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        state.meta.toughnessIncreaseEffectId = container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Toughness, state.args.increase),
            duration: Duration_1.Duration.Instant,
            supernatural: true
        });
        state.meta.vitalityIncreaseEffectId = container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Vitality, state.args.increase),
            duration: Duration_1.Duration.Instant,
            supernatural: true
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        container.cancelEffect(sequence, state.meta.toughnessIncreaseEffectId);
        container.cancelEffect(sequence, state.meta.vitalityIncreaseEffectId);
    }
};
ImpenetrableDefenseEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.ImpenetrableDefense)
], ImpenetrableDefenseEffectHandler);
exports.ImpenetrableDefenseEffectHandler = ImpenetrableDefenseEffectHandler;
